module.exports = __webpack_public_path__ + "img/home-insurance.d662140b.png";